import type { IDocument, IVehicleFuelEntry, IVehicleFuelEntryForm } from '@/interfaces'
import type { IDecimalValueAndUnit } from '@/interfaces/IDecimalValueAndUnit'
import DecimalValueAndUnit from '../DecimalValueAndUnit'
import DocumentModel from '../DocumentModel'

class VehicleFuelEntryForm implements IVehicleFuelEntryForm {
  timestamp: string

  odometerReading: IDecimalValueAndUnit

  fuelVolume: IDecimalValueAndUnit

  fuelCost: IDecimalValueAndUnit

  fuelType?: string

  hasUsedFuelCard: boolean

  invoiceNumber?: string

  comments: string

  documents: IDocument[]

  fuelEconomy?: IDecimalValueAndUnit

  constructor(fuelEntry?: any) {
    this.timestamp = fuelEntry?.timestamp
    this.odometerReading = new DecimalValueAndUnit(fuelEntry?.odometerReading)
    this.fuelVolume = new DecimalValueAndUnit(fuelEntry?.fuelVolume)
    this.fuelCost = new DecimalValueAndUnit(fuelEntry?.fuelCost)
    this.fuelType = fuelEntry?.fuelType
    this.hasUsedFuelCard = fuelEntry?.hasUsedFuelCard ?? false
    this.invoiceNumber = fuelEntry?.invoiceNumber ?? ''
    this.comments = fuelEntry?.comments ?? ''
    this.documents = fuelEntry?.documents?.map((document: any) => new DocumentModel(document)) ?? []
    this.fuelEconomy = new DecimalValueAndUnit(fuelEntry?.fuelEconomy)
  }
}

export default VehicleFuelEntryForm
